import type { SomnologyOrganizationType } from '../../../../../common/enums/SomnologyOrganizationType';
import { translateKey } from '../../../../translate';
import { DeprecatedOsasFaqCard } from '../faqCards/DeprecatedOsasFaqCard';

/**
 * @deprecated This component should be phased out with the old OSAS carepath
 */
export function DeprecatedOsasInformation(props: Readonly<{ somnologyOrganizationType?: SomnologyOrganizationType }>) {
    return (
        <DeprecatedOsasFaqCard
            lg={12}
            returnTo={translateKey('common.home')}
            somnologyOrganizationType={props.somnologyOrganizationType}
        />
    );
}
